import custStructureReport from './custStructureReport'
export default custStructureReport
